import { createContext } from 'react'
import type { MatterTable } from '../schemas'

export const TableTitlesContext = createContext<{
  tablesByMatter: Record<string, MatterTable[] | null>
  load: (matterId: string, force?: boolean) => void
  refresh: () => void
} | null>(null)
